import ShoppingBagTrolleyIconPath from "@ingka/ssr-icon/paths/shopping-bag-trolley";

export default ShoppingBagTrolleyIconPath;
